module.exports = __webpack_public_path__ + "img/pig_arrow.ac77fd43.svg";